export class VerifyMftConnectionDto {
  type: string;

  constructor(type: string) {
    this.type = type;
  }
}
